


function Bottom() {
  return (
    <div className="bottom">
    <span style={{color:"#3c9cda"}}>E</span>
    <span style={{color:"#fad033"}}>N</span>
    <span style={{color:"#e73e33"}}>J</span>
    <span style={{color:"#5ab037"}}>O</span>
    <span style={{color:"#fad033"}}>Y</span>
    </div>
  )
}

export default Bottom